module.exports = __webpack_public_path__ + "img/personalPhotoes-active.f3df2ddd.svg";